import { render, staticRenderFns } from "./TheSuggestion.vue?vue&type=template&id=34cd376a&scoped=true&"
import script from "./TheSuggestion.vue?vue&type=script&lang=js&"
export * from "./TheSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./TheSuggestion.vue?vue&type=style&index=0&id=34cd376a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cd376a",
  null
  
)

export default component.exports